import { createPPT } from '~app/core/pptxgen';
import { t } from "~app/AppBundleContext";
import { createMessage, startLoading, finishLoading } from './app';
import { unselectNodes } from './nodeList';

export function exportPowerPoint(bannerURL) {
  return async (dispatch, getState) => {
    dispatch(startLoading(t("saving-ppt")));
    dispatch(unselectNodes());
    
    const state = getState();
    const failedToGetImage = await createPPT(state, bannerURL);

    dispatch(finishLoading());
    if (failedToGetImage) {
      const message = t("ppt-failed");
      const subMessage = t("ppt-no-map");
      dispatch(createMessage(message, "danger", subMessage));
    }
    else {
      dispatch(createMessage(t("ppt-saved"), "success"));
    }

  };
}



// WEBPACK FOOTER //
// ./src/actions/pptxgen.js